import React from "react";
import AppRoutes from "pages/routes";
import GlobalStore from "stores/globalStore";
import CartProvider from 'stores/CartProvider';
import env from "utils/env";
import { Helmet } from 'react-helmet';

const App: React.FC = () => {
  env();

  return (
    <div className="App">
      <Helmet>
        <title>User Dashboard</title>
        <meta name="description" content="Web site created using create-react-app"/>  
        <link rel="canonical" href={window.location.href} /> 
      </Helmet>
      <GlobalStore.Provider>
        <CartProvider>
          <AppRoutes />
        </CartProvider>
      </GlobalStore.Provider>
    </div>
  );
};

export default App;
